import { render, staticRenderFns } from "./quantity-tab.vue?vue&type=template&id=abcc2b56&scoped=true"
import script from "./quantity-tab.vue?vue&type=script&lang=js"
export * from "./quantity-tab.vue?vue&type=script&lang=js"
import style0 from "./quantity-tab.vue?vue&type=style&index=0&id=abcc2b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcc2b56",
  null
  
)

export default component.exports